import { FormFieldConfig } from "Components/Common/CommonForm";
import { validations } from "validations/FormValidations";

export const aliquotFields:FormFieldConfig[] = [
  {
    name: "aliquot_sort",
    label: "Aliquot Number",
    placeholder: "Enter aliquot number",
    type: "number",
    required: true,
    rules: validations.aliquot.aliquot_sort,
  },
  {
    name: "aliquot_number",
    label: "Display Aliquot",
    placeholder: "Enter display aliquot",
    type: "text",
    required: true,
    rules: validations.aliquot.aliquot_number,
  },
];


export const aliquotColumn = [
  { key: "aliquot_sort", label: "Aliquot No" },
  { key: "aliquot_number", label: "Display Aliquot" },
];